import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import { api } from "@/lib/api";
import { PageToolbar, usePageTranslation } from "@/components/PageToolbar";

export default function Cities() {
  const [cities, setCities] = useState([]);

  useEffect(() => {
    api.get("/cities").then((r) => setCities(r.data));
  }, []);

  const blocks = useMemo(() => {
    if (!cities.length) return null;
    const b = { title: "Film Cities", sub: "Theaters, festivals, shoots and screen memories — the cities where cinema lives day to day." };
    cities.forEach((c) => (b[`ov-${c.id}`] = c.overview));
    return b;
  }, [cities]);
  const { lang, tr, busy } = usePageTranslation(blocks, "cities-list");

  return (
    <main data-testid="cities-page" className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
      <p className="eyebrow">Everyday Cinema & Production</p>
      <h1 className="font-display font-bold text-4xl sm:text-5xl mt-2 text-[#1c1512]">{tr("title", "Film Cities")}</h1>
      <p className="text-[#6b5d51] mt-3 max-w-2xl">{tr("sub", "Theaters, festivals, shoots and screen memories — the cities where cinema lives day to day.")}</p>
      <div className="mt-5">
        <PageToolbar speakText={cities.map((c) => `${c.name}: ${tr(`ov-${c.id}`, c.overview)}`).join(" ")} busy={busy} lang={lang} />
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-10">
        {cities.map((c) => (
          <Link key={c.id} to={`/city/${c.id}`} data-testid={`city-card-${c.id}`} className="poster-card bg-[#fbf8f1] border border-[#d8ccb8] p-6 group">
            <p className="flex items-center gap-1.5 font-mono-label text-[10px] tracking-[0.22em] uppercase text-[#8a7c6d]">
              <MapPin className="w-3.5 h-3.5 text-[#7d1a1a]" /> {c.country}
            </p>
            <h2 className="font-display font-bold text-2xl mt-2 group-hover:text-[#7d1a1a] transition-colors">{c.name}</h2>
            <p className="font-script text-xl text-[#b06810] mt-1">{c.tagline}</p>
            <p className="text-sm text-[#6b5d51] mt-3 line-clamp-3">{tr(`ov-${c.id}`, c.overview)}</p>
            <p className="flex items-center gap-1 text-sm font-medium text-[#7d1a1a] mt-4">
              Visit city cinema home <ArrowRight className="w-4 h-4" />
            </p>
          </Link>
        ))}
      </div>
    </main>
  );
}
